import { Button, Tooltip } from '$components'
import { useEditVeterinaryInformationForm } from './index'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export function EditVeterinaryInformationControls() {
  const { onCancel, isLoading } = useEditVeterinaryInformationForm()
  const { hasSubscriptionExpired } = useTenant()

  const isButtonDisabled = hasSubscriptionExpired || isLoading

  return (
    <div className="flex gap-stack-roomy mt-auto ml-auto">
      <Button
        type="button"
        variant="ghost"
        size="lg"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Tooltip
        content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
        disabled={!hasSubscriptionExpired}
      >
        <Button
          isLoading={isLoading}
          type="submit"
          size="lg"
          disabled={isButtonDisabled}
        >
          Save Changes
        </Button>
      </Tooltip>
    </div>
  )
}
